import { useState, useEffect } from 'react';
import { useAuthCliente } from '../context/AuthClienteContext';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

export function useComments(announcementId) {
  const { currentUser } = useAuthCliente();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.companyId || !announcementId) {
      setLoading(false);
      return;
    }

    const ref = collection(db, 'companies', currentUser.companyId, 'announcements', announcementId, 'comments');
    const q = query(ref, orderBy('createdAt', 'asc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setComments(data);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching comments:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser?.companyId, announcementId]);

  return { comments, loading };
}